<template>
  <v-card class="elevation-1 mb-6">
    <v-card-title class="pa-7">
      Přehled promo kódů
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        height="40px"
        min-width="130px"
        class="mr-2"
        depressed
        @click.prevent="openAddPromoCodeDialog()"
      >
        Nový kód
      </v-btn>
      <v-btn
        color="primary"
        height="40px"
        min-width="130px"
        depressed
        @click.prevent="openUploadPromoCodeDialog()"
      >
        Import se souboru
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        v-model="promoCode.selected"
        :headers="userHeadersByRole"
        :items="promoCode.items"
        :options.sync="promoCode.options"
        :server-items-length="promoCode.serverItemsLength"
        :loading="promoCode.loading"
        item-key="id"
        class="elevation-0"
        show-select
      >
        <template v-slot:item.used="{ item }">
          <YesNo :value="item.used" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :disable-time="false" :datetime="item.createdAt" />
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <DateTime :disable-time="false" :datetime="item.updatedAt" />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle color="primary" dense group>
            <v-btn v-if="!item.used" color="blue-grey" text @click="removePromoCode(item.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card-text>
    <PromoCodeAddDialog @promoCodeAdded="promoCodeAdded" />
    <PromoCodeUploadDialog @promoCodeUploaded="promoCodeUploaded" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber'
import PromoCodeAddDialog from '../../../../components/gift/promo/PromoCodeAddDialog'
import YesNo from '../../../../components/YesNo'
import PromoCodeUploadDialog from '../../../../components/gift/promo/PromoCodeUploadDialog'

export default {
  name: 'PromoCodes',
  components: {
    PromoCodeUploadDialog,
    YesNo,
    PromoCodeAddDialog,
    DateTime,
  },
  mixins: [setFilters, formatPhoneNumber],
  data() {
    return {
      promoCode: {
        selected: [],
        headers: [
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Kód',
            value: 'code',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Odeslaný',
            value: 'used',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Vytvořeno',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Změněno',
            value: 'updatedAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      promoCodeFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.promoCode.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'promoCode.options': {
      handler() {
        this.loadPromoCodes()
      },
    },
    '$route.query': {
      handler() {
        this.loadPromoCodes()
      },
    },
    'promoCode.selected': {
      handler() {
        this.promoCodeFooter.selectedData.items = this.promoCode.selected
      },
    },
  },
  methods: {
    ...mapActions({
      searchPromoCodes: 'promo/searchPromoCodes',
      deletePromoCode: 'promo/deletePromoCode',
    }),
    loadPromoCodes() {
      this.promoCode.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.promoCode.options,
      }
      this.promoCodeFooter.selectedData.params = searchParams
      this.searchPromoCodes({ giftId: this.$route.params.giftId, params: searchParams })
        .then((response) => {
          this.promoCodeFooter.totalElements = response.data.totalElements
          this.promoCode.items = response.data.items
          this.promoCode.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.promoCode.loading = false
        })
    },
    setFiltersAction(filters) {
      this.promoCode.options.page = 1
      this.setFilters(filters)
    },
    removePromoCode(id) {
      this.$confirm('', {
        title: 'Smazat promo kód?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.promoCode.loading = true
          this.deletePromoCode({ giftId: this.$route.params.giftId, promoCodeId: id })
            .then(() => {
              this.loadPromoCodes()
            })
            .finally(() => {
              this.promoCode.loading = false
            })
        }
      })
    },
    openAddPromoCodeDialog() {
      this.$eventBus.$emit('addPromoCodeDialog', true)
    },
    openUploadPromoCodeDialog() {
      this.$eventBus.$emit('promoCodeUploadDialog', true)
    },
    promoCodeAdded() {
      this.loadPromoCodes()
    },
    promoCodeUploaded() {
      this.loadPromoCodes()
    },
  },
}
</script>
